import { accessTokenIdentity } from '@/services/authSessionClaims';
import { getAccessToken, getSessionIdentityGeneration } from '@/services/authTokenStorage';

/** No raw credential enters query keys or mutation state. */
export function getSessionOriginKey(): string | null {
  const identity = accessTokenIdentity(getAccessToken());
  return identity === null ? null : JSON.stringify([identity, getSessionIdentityGeneration()]);
}

export function isCurrentSessionOrigin(origin: string | null): boolean {
  return origin !== null && origin === getSessionOriginKey();
}
